<template>
  <KTCard :title="title" :subtitle="subTitle" :loading="loading">
    <template v-slot:body>
      <!-- flota form -->
      <b-form class="form" @submit.prevent="onSubmit">
        <!-- codigo -->
        <b-form-group
          label="Código *"
          label-for="codigo"
          description="Escriba el código de la flota"
        >
          <b-form-input
            id="codigo"
            v-model="flota.id_flota"
            type="text"
            required
            placeholder="Código"
          ></b-form-input>
        </b-form-group>
        <!-- literal -->
        <b-form-group
          label="Literal de Flota *"
          label-for="literal"
          description="Escriba el literal"
        >
          <b-form-input
            id="literal"
            v-model="flota.descripcion"
            type="text"
            required
            placeholder="Literal de Flota"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end span-3">
          <b-button class="mr-2" @click="cancel()">Cancelar</b-button>
          <b-button type="submit" variant="primary">Guardar</b-button>
        </div>
      </b-form>
    </template>
  </KTCard>
</template>

<script>
import KTCard from "@/view/content/Card.vue";
import { ADD_FLOTA, EDIT_FLOTA } from "@/core/services/store/flotas.module";
import ApiService from "@/core/services/api.service";

export default {
  name: "flotas-add",
  components: {
    KTCard
  },
  data() {
    return {
      loading: false,
      flota: {
        id_flota: null,
        descripcion: ""
      }
    };
  },
  computed: {
    title() {
      return this.isEdit ? "Editar flota" : "Nueva flota";
    },
    subTitle() {
      return this.isEdit ? "Modifique los datos" : "Escriba todos los datos";
    },
    isEdit() {
      return this.$route.params.id !== undefined;
    }
  },
  async mounted() {
    if (this.isEdit) {
      this.loading = true;
      const resp = await ApiService.get(
        `dic_flotas?id=${this.$route.params.id}`
      );
      this.flota = resp.data.result[0];
      this.loading = false;
    }
  },
  methods: {
    cancel() {
      this.loading = false;
      this.$router.push("/lists/flotas");
    },
    onSubmit() {
      this.loading = true;
      if (this.isEdit) {
        this.$store.dispatch(EDIT_FLOTA, this.flota).then(() => {
          this.cancel();
        });
      } else {
        this.$store.dispatch(ADD_FLOTA, this.flota).then(() => {
          this.cancel();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/pages/users/add";
</style>
